"use client";

import { create } from "zustand";
import { persist } from "zustand/middleware";

export const PERSONAS = [
  "tuition-centre",
  "coaching-institute",
  "music-dance-academy",
  "multi-branch",
] as const;

export type Persona = (typeof PERSONAS)[number];

interface PersonaState {
  persona: Persona;
  setPersona: (persona: Persona) => void;
}

/**
 * Visitor's persona lens. Persisted so the lens follows them across pages.
 * Hydration is deferred (`skipHydration`) so server HTML (default persona)
 * matches the first client render; `PersonaChips` rehydrates after mount.
 */
export const usePersonaStore = create<PersonaState>()(
  persist(
    (set) => ({
      persona: "tuition-centre",
      setPersona: (persona) => set({ persona }),
    }),
    { name: "eg-marketing-persona", skipHydration: true }
  )
);
